module.exports = __webpack_public_path__ + "static/img/P4.3066b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/P4.png
// module id = Os2D
// module chunks = 0